export const ROUTE_HOME = '/home';
export const ROUTE_HOME_INDEX = '/index.html';
export const ROUTE=  '/';

export const ROUTE_PROFILAZIONE = '/qualifiche';
export const ROUTE_FROM_PEGNI ='/MP';
export const ROUTE_FROM_UNIMODWEB ='/UN';
export const ROUTE_FROM_UNIMODWEB_BB ='/BU';
export const ROUTE_FROM_PEGNI_CERTIFICATI ='/CP';
export const ROUTE_FROM_CANCELLAZIONI_IPOTECA ='/CI';

export const ROUTE_TRASMISSIONE = '/trasmissione';
export const ROUTE_RICEVUTE = '/ricevute';
export const ROUTE_ESITI_CONTESTUALI = '/esiti-contestuali';
export const ROUTE_ELENCHI = '/elenchi';
export const ROUTE_RICEVUTE_DETTAGLIO = '/ricevute/dettaglio';
export const ROUTE_RICEVUTE_DETTAGLIO_2 = '/ricevute/dettaglioII';
export const ROUTE_RICEVUTE_DETTAGLIO_AVVISO = '/ricevute/dettaglio/avviso';
export const ROUTE_PAGAMENTO_INTEGRATIVO = '/pagamento-integrativo';


export const ROUTE_SERVIZI = '/servizi';
export const ROUTE_DOCUMENTAZIONE = '/documentazione';
export const ROUTE_RESTITUZIONE_DUPLO = '/restituzione-duplo';
export const ROUTE_DUPLI_RESTITUITI = '/dupli-restituiti';

export const ROUTE_ASSISTENZA = '/assistenza';

export const ROUTE_FERMO = '/fermo';
export const ROUTE_ERROR = "/error";


export const ROUTE_COMPILAZIONE_MUI = "/UnimodWeb/compilazione";
export const ROUTE_COMPILAZIONE_CI = "/CCiWeb/compilazione";
export const ROUTE_HOME_CI = "/CCiWeb/home";

